import { IOrderItem } from 'types/orders';

import { IOrderItemApi } from '../types';

export function mapOrderItem(apiItem: IOrderItemApi): IOrderItem {
  return {
    ...apiItem
  };
}
